import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DataService } from '../../../../data.service';
import { GeneralService } from '../../../../general.service';
import {TranslateService} from '@ngx-translate/core';
import { CKEditor4 } from 'ckeditor4-angular';
import { Subscription } from 'rxjs';
import { WordcountService } from '../../../../wordcount.service';

declare var decimalInput: any;
declare function startMap(): any

@Component({
  selector: 'app-imagemap',
  templateUrl: './imagemap.html',
  styleUrls: ['./imagemap.scss']
})

export class ImageMap implements OnInit {

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public forceMapSelection = false;
  public chosenMap = "";
  public mapData = "";
  public shownMaps:string[] = [];
  public ckeConfig:any;
  public zoom = {
    currentZoom: 100,
    defaultZoom: 100,
    maxZoom: 200,
    minZoom: 10,
    zoomInEnabled: true,
    zoomOutEnabled: true,
    zoomIncrement: 10
  };
 
  private loadAnswersSubscription : Subscription;

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService,
    public wordCount: WordcountService
  ) { 
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }

     this.ckeConfig = {
      toolbarGroups: [
        { name: 'styles', groups: ['styles'] },
        { name: 'basicstyles', groups: ['basicstyles'] },
        { name: 'colors', groups: ['colors'] },
        { name: 'paragraph', groups: ['list', 'blocks', 'align', 'indent', 'bidi', 'paragraph'] }
    ],
      resize_enabled : false,
      resizable: false,
      allowedContent: true,
      removeFormatAttributes :'',
    };

    this.loadAnswersSubscription = this.dataSvc.getLoadImageMapAnswersEvent().subscribe(()=>{
      this.loadAnswers();
    });
  }

  resetVariables(){
    this.shownMaps = [];
    this.forceMapSelection = false;
    this.chosenMap = "";
    this.mapData = "";
  }

  ngOnInit(): void {
    this.loadAnswers();
  }

  loadAnswers() {
    this.resetVariables();
    if(this.dataSvc.currentQuestion().Question.QuestionType !== 1025) return;

    this.resetZoom();

    clearInterval();
    //GET METADATA OF IMAGE MAP QUESTION
    //BASED ON CREATION USES SPLITS AND SUBSTRING TO GET THE DATA IN THE FORMAT THAT IT NEEDS
    var mapQuestion = this.dataSvc.currentQuestion().Question;
    if(mapQuestion !== null && mapQuestion !== undefined){

      //INITIATE WORD COUNT LOGIC
    if(mapQuestion.Question.WordCount !== null && mapQuestion.Question.WordCount !== undefined
    && mapQuestion.Question.WordCount > 0){
      this.wordCount.wordcount = mapQuestion.Question.WordCount;
      // setInterval(()=>{
      //   this.wordCount.userWords = this.dataSvc.countAnswersWords();
      // },1000);
    }

      this.mapData = mapQuestion.Question.Metadata.toString();
      if(this.mapData !== null && this.mapData !== undefined && this.mapData !== ""){
        var hdfQuestion = (<HTMLInputElement>document.getElementById("hdfQuestionID"));
        if(hdfQuestion !== null && hdfQuestion !== undefined){
          hdfQuestion.value = mapQuestion.Question.QuestionID;
        }

        var alreadyChosen = localStorage.getItem(mapQuestion.Question.QuestionID + "_chosenMap");
        if(alreadyChosen !== null && alreadyChosen !== undefined && alreadyChosen !== ""){
          this.forceMapSelection = false;
          this.mapData = this.mapData.replace("$$$Force$$$", "");
        }
        else{
          
          //DETERMINES WHETHER OR NOT MAPPING NEEDS TO BE SELECTED
          if(this.mapData.indexOf("$$$Force$$$") > -1){
            this.forceMapSelection = true;
            this.mapData = this.mapData.replace("$$$Force$$$", "");
          }
          else{
            this.forceMapSelection = false;
          }
        }
        
        this.mapData = this.mapData.replace(new RegExp("&#39", "g"), "").replace(new RegExp("&amp;#39;", "g"), "").replace(new RegExp("'", "g"), "\"");
        //this.mapData = this.mapData.replace(/src=['"](?:[^"'\/]*\/)*([^'"]+)['"]/g, "src='https://cimg.visitscotland.com/cms-images/header-images/ois/lochan-urr-glen-etive'/$1'");

        //CHECK IF THE ANSWER CONTAINS THE CHOSEN MAP, INCASE LOCALSTROAGE IS CLEAR
        var response = this.dataSvc.currentQuestion().Result.Selection;        
        if(response.indexOf("%%%ChosenMap") > -1){
          this.forceMapSelection = false;
          var first = response.indexOf("%%%ChosenMap");
          var last = response.lastIndexOf("%%%") + 3;

          var toAnswer1 = response.indexOf("%%%ChosenMap") + 12;
          var toAnswer2 = response.lastIndexOf("%%%");
          this.chosenMap =  response.substring(toAnswer1, toAnswer2);
          
          localStorage.setItem(mapQuestion.Question.QuestionID + "_chosenMap", this.chosenMap); 
          var replaceTxt =  response.substring(first, last);
          response= response.replace(replaceTxt, "");
        }

        //CALLS JS FUNCTION IN MAIN INDEX.HTML FILE WHICH BUILDS THE MAPPINGS
        startMap();
      }
    }
  }

  openCloseThis(id) {
    //OPERATES THE QUESTION ACCORDION WHICH APPEARS INSIDE THE TAB MODAL
    var content = document.getElementById(id).parentElement;
    var collapse = content.querySelector('.collapse');
    var itag = content.querySelector("i");
    if(collapse.classList.contains('in')){
      collapse.classList.remove('in');
      itag.classList.add("glyphicon-plus");
      itag.classList.remove("glyphicon-minus");
    }
    else{
      collapse.classList.add('in');
      itag.classList.remove("glyphicon-plus");
      itag.classList.add("glyphicon-minus");
    }
}

  selectMap(){
    //IF FORCE SELECTION IS ENABLED FOR TAB QUESTION, THIS WILL SELECT THE TAB PERMANENTLY
    var cfmMsg = "";
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      if(exisitingLangauge == "en"){
        cfmMsg = "Are you sure you want to to select this map, you wont be able to change at a later date?";
      }
      else if(exisitingLangauge == "nl"){
        cfmMsg = "Weet u zeker dat u deze kaart wilt selecteren, u kunt deze later niet meer wijzigen?";
      }
    }
    else{
      cfmMsg = "Are you sure you want to to select this map, you wont be able to change at a later date?";
    }
    var cnf = confirm(cfmMsg);
    if(cnf){
      var cm = (<HTMLInputElement>document.getElementById("lblChosenArticle")).innerText;    
      this.chosenMap = cm;
      if(this.chosenMap !== ""){   
        var question = this.dataSvc.currentQuestion();
        localStorage.setItem(question.Question.Question.QuestionID + "_chosenMap", this.chosenMap);         
        this.forceMapSelection = false;
        (<HTMLInputElement>document.getElementById("hdfQuestionID")).value = question.Question.Question.QuestionID;
      }
    }
  }

  saveQuestion(){
    if(this.chosenMap !== null && this.chosenMap !== undefined && this.chosenMap !== ""){
      var answer = this.dataSvc.currentQuestion().Result.Selection;
      if(answer.indexOf("%%%ChosenMap") == -1){
        var answerString = "<p style='display:none;color:white;background:white;font-size:1px;opacity:0;'>%%%ChosenMap" + this.chosenMap.replace("li", "") + "%%%</p>" + answer;
        this.dataSvc.currentQuestion().Result.Selection = answerString;
      }      
      document.getElementById("mapModal").style.display = "none";
      document.getElementById("mapModal").classList.remove("show");
    }
    else{
      document.getElementById("mapModal").style.display = "none";
      document.getElementById("mapModal").classList.remove("show");
    }
  }

  zoomOut() {
    this.setZoomFactor(-this.zoom.zoomIncrement);
  }

  zoomIn() {
    this.setZoomFactor(this.zoom.zoomIncrement);
  }

  resetZoom() {
    this.setZoom(this.zoom.defaultZoom);
    this.validateZoomControls();
  }

  setZoomFactor(factor) {
    this.setZoom(this.zoom.currentZoom + Math.round(factor));
  }

  setZoom(val) {
    this.zoom.currentZoom = val;
    this.updateImageMapZoom();
    this.validateZoomControls();
  }

  updateImageMapZoom() {
    (<HTMLDivElement>document.getElementsByClassName("imageMapArea")[0]).style.setProperty('transform', 'scale(' + (this.zoom.currentZoom/100).toString() + ')');
    (<HTMLDivElement>document.getElementsByClassName("imageMapArea")[0]).style.setProperty('transform-origin', 'top left');
    (<HTMLDivElement>document.getElementsByClassName("imageMapArea")[0]).style.setProperty('-moz-transform', 'scale(' + (this.zoom.currentZoom/100).toString() + ')');
    (<HTMLDivElement>document.getElementsByClassName("imageMapArea")[0]).style.setProperty('-moz-transform-origin', 'top left');
    //$(".imageMapArea").css("zoom", this.zoom.currentZoom/100);
  }

  validateZoomControls() {
    this.zoom.zoomOutEnabled = this.zoom.currentZoom != this.zoom.minZoom;
    this.zoom.zoomInEnabled = this.zoom.currentZoom != this.zoom.maxZoom;
  }
}
